import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import globalParams from './modules/globalParams'
import language from './modules/language'
Vue.use(Vuex)
Vue.config.devtools = true
const modules = {
    user,
    globalParams,
    language
}
let store = null
export default  store  = new Vuex.Store({
    actions: {},
    mutations: {},
    getters: {},
    modules
})

/* 重置store方法
*
*/
export function resetStoreState (oWhiteList=[]) {
    //不重置白名单
    let whiteList  = ['language']
    Object.keys(modules).forEach(key=>{
        if(!whiteList.includes(key)){
            console.log(key)
            store.commit(`${key}ResetStore`)
        }

    })
}
